"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ChatList = _interopRequireDefault(require("./ChatList.scss"));

function ChatList(_ref) {
  var children = _ref.children;
  var divRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    divRef.current.scrollTop = divRef.current.scrollHeight;
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: divRef,
    className: _ChatList["default"].chatlist
  }, children);
}

ChatList.propTypes = {
  children: _propTypes["default"].node
};
var _default = ChatList;
exports["default"] = _default;